(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ekspert_rady"] && !Shopify.designMode) return;
  try {
    class EkspertPorady extends HTMLElement {
    connectedCallback() {
      this.lista = this.querySelector('[data-ekspert-lista]');
      this.suwak = this.querySelector('[data-ekspert-suwak]');
      this.pozycja = this.querySelector('[data-ekspert-pozycja]');
      this.wstecz = this.querySelector('[data-ekspert-wstecz]');
      this.dalej = this.querySelector('[data-ekspert-dalej]');
      if (!this.lista || !this.suwak) return;
      this.liczba = this.lista.children.length;
      this.lista.addEventListener('scroll', this.planuj, { passive: true });
      this.wstecz?.addEventListener('click', this.poprzednia);
      this.dalej?.addEventListener('click', this.nastepna);
      this.obserwator = new ResizeObserver(this.planuj);
      this.obserwator.observe(this.lista);
      this.aktualizuj();
    }

    disconnectedCallback() {
      this.lista?.removeEventListener('scroll', this.planuj);
      this.wstecz?.removeEventListener('click', this.poprzednia);
      this.dalej?.removeEventListener('click', this.nastepna);
      this.obserwator?.disconnect();
      if (this.klatka) cancelAnimationFrame(this.klatka);
    }

    planuj = () => {
      if (this.klatka) return;
      this.klatka = requestAnimationFrame(() => {
        this.klatka = null;
        this.aktualizuj();
      });
    };

    /** Maksymalne przewinięcie listy (0 = wszystkie karty mieszczą się bez przewijania). */
    get zakres() {
      return Math.max(0, this.lista.scrollWidth - this.lista.clientWidth);
    }

    /** Pozycja przewinięcia, przy której karta zaczyna się na początku listy (ograniczona do zakresu). */
    get pozycje() {
      const lista = this.lista;
      const start = lista.getBoundingClientRect().left + parseFloat(getComputedStyle(lista).paddingLeft);
      const zakres = this.zakres;
      return Array.from(lista.children, (karta) =>
        Math.min(zakres, Math.max(0, karta.getBoundingClientRect().left - start + lista.scrollLeft))
      );
    }

    get indeks() {
      const zakres = this.zakres;
      if (zakres <= 2) return 0;
      const teraz = this.lista.scrollLeft;
      if (teraz >= zakres - 2) return this.lista.children.length - 1;
      let indeks = 0;
      let najblizej = Infinity;
      this.pozycje.forEach((p, i) => {
        const odleglosc = Math.abs(p - teraz);
        if (odleglosc < najblizej) {
          najblizej = odleglosc;
          indeks = i;
        }
      });
      return indeks;
    }

    przewinDo(lewo) {
      const plynnie = !matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.lista.scrollTo({ left: lewo, behavior: plynnie ? 'smooth' : 'auto' });
    }

    // Wstecz/dalej liczone od bieżącej pozycji, a nie od indeksu: przy końcu listy kilka kart
    // ma tę samą (ograniczoną) pozycję, więc „indeks − 1” mogłoby nie przesunąć karuzeli.
    poprzednia = () => {
      const teraz = this.lista.scrollLeft;
      const cel = this.pozycje.filter((p) => p < teraz - 2).pop();
      this.przewinDo(cel ?? 0);
    };

    nastepna = () => {
      const teraz = this.lista.scrollLeft;
      const cel = this.pozycje.find((p) => p > teraz + 2);
      this.przewinDo(cel ?? this.zakres);
    };

    aktualizuj() {
      const i = this.indeks;
      this.suwak.style.transform = `translateX(${i * 100}%)`;
      if (this.pozycja) this.pozycja.textContent = `${i + 1} / ${this.liczba}`;
      if (this.wstecz) this.wstecz.disabled = i === 0;
      if (this.dalej) this.dalej.disabled = i === this.liczba - 1 || this.zakres <= 2;
    }
  }

  if (!customElements.get('ekspert-porady')) {
    customElements.define('ekspert-porady', EkspertPorady);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["komunikaty_promocyjne"] && !Shopify.designMode) return;
  try {
    class KomunikatyPromocyjne extends HTMLElement {
    connectedCallback() {
      this.odswiez();
    }

    disconnectedCallback() {
      clearTimeout(this.zegar);
    }

    odswiez() {
      const teraz = Date.now() / 1000;
      let nastepna = Infinity;
      for (const komunikat of this.querySelectorAll('[data-komunikat]')) {
        const od = Number(komunikat.dataset.od) || 0;
        const doCzasu = Number(komunikat.dataset.do) || 0;
        const widoczny = (!od || od <= teraz) && (!doCzasu || doCzasu > teraz);
        komunikat.hidden = !widoczny;
        if (od > teraz) nastepna = Math.min(nastepna, od);
        if (doCzasu > teraz) nastepna = Math.min(nastepna, doCzasu);
      }
      clearTimeout(this.zegar);
      const za = (nastepna - teraz) * 1000;
      if (Number.isFinite(za) && za < 2147483647) {
        this.zegar = setTimeout(() => this.odswiez(), za + 500);
      }
    }
  }

  if (!customElements.get('komunikaty-promocyjne')) {
    customElements.define('komunikaty-promocyjne', KomunikatyPromocyjne);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["raporty_badan"] && !Shopify.designMode) return;
  try {
    class RaportyBadan extends HTMLElement {
    connectedCallback() {
      this.lista = this.querySelector('[data-raporty-lista]');
      this.suwak = this.querySelector('[data-raporty-suwak]');
      this.pozycja = this.querySelector('[data-raporty-pozycja]');
      this.wstecz = this.querySelector('[data-raporty-wstecz]');
      this.dalej = this.querySelector('[data-raporty-dalej]');
      this.lightbox = this.querySelector('[data-raporty-lightbox]');
      this.addEventListener('click', this.handleClick);
      this.lightbox?.addEventListener('click', this.handleLightboxClick);
      this.lightbox?.addEventListener('cancel', this.handleCancel);
      if (!this.lista || !this.suwak) return;
      this.liczba = this.lista.children.length;
      this.klatka = null;
      this.lista.addEventListener('scroll', this.handleScroll, { passive: true });
      this.wstecz?.addEventListener('click', this.poprzedni);
      this.dalej?.addEventListener('click', this.nastepny);
      this.obserwator = new ResizeObserver(this.handleScroll);
      this.obserwator.observe(this.lista);
      this.update();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.lightbox?.removeEventListener('click', this.handleLightboxClick);
      this.lightbox?.removeEventListener('cancel', this.handleCancel);
      document.documentElement.classList.remove('raporty-lightbox-otwarty');
      this.lista?.removeEventListener('scroll', this.handleScroll);
      this.wstecz?.removeEventListener('click', this.poprzedni);
      this.dalej?.removeEventListener('click', this.nastepny);
      this.obserwator?.disconnect();
      if (this.klatka) cancelAnimationFrame(this.klatka);
    }

    handleScroll = () => {
      if (this.klatka) return;
      this.klatka = requestAnimationFrame(() => {
        this.klatka = null;
        this.update();
      });
    };

    handleClick = (event) => {
      const wyzwalacz = event.target.closest('[data-raport-otworz]');
      if (!wyzwalacz || !this.lightbox || event.ctrlKey || event.metaKey || event.shiftKey) return;
      const typ = wyzwalacz.dataset.raportTyp;
      if (typ === 'pdf' && !this.pdfWStronie()) return;
      event.preventDefault();
      this.otworz(wyzwalacz.href, typ, wyzwalacz.dataset.raportTytul || '');
    };

    pdfWStronie() {
      const ios = /iP(hone|ad|od)/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      return !ios && navigator.pdfViewerEnabled !== false;
    }

    otworz(url, typ, tytul) {
      const tresc = this.lightbox.querySelector('[data-raporty-lightbox-tresc]');
      tresc.replaceChildren();
      if (typ === 'pdf') {
        const ramka = document.createElement('iframe');
        ramka.src = url;
        ramka.title = tytul;
        ramka.className = 'raporty-lightbox__pdf';
        tresc.append(ramka);
      } else {
        const obraz = document.createElement('img');
        obraz.src = url;
        obraz.alt = tytul;
        obraz.className = 'raporty-lightbox__obraz';
        tresc.append(obraz);
      }
      this.lightbox.querySelector('[data-raporty-lightbox-tytul]').textContent = tytul;
      this.lightbox.querySelector('[data-raporty-lightbox-link]').href = url;
      this.wyzwalacz = document.activeElement;
      const panel = this.lightbox.querySelector('.t-modal');
      panel.classList.remove('is-closing');
      this.lightbox.showModal();
      document.documentElement.classList.add('raporty-lightbox-otwarty');
      void panel.offsetWidth;
      panel.classList.add('is-open');
      this.lightbox.classList.add('is-open');
    }

    zamknij() {
      if (!this.lightbox?.open) return;
      const panel = this.lightbox.querySelector('.t-modal');
      const czas = parseFloat(getComputedStyle(this.lightbox).getPropertyValue('--modal-close-dur')) || 150;
      panel.classList.remove('is-open');
      panel.classList.add('is-closing');
      this.lightbox.classList.remove('is-open');
      clearTimeout(this.zamykanie);
      this.zamykanie = setTimeout(() => {
        panel.classList.remove('is-closing');
        this.lightbox.close();
        this.lightbox.querySelector('[data-raporty-lightbox-tresc]').replaceChildren();
        document.documentElement.classList.remove('raporty-lightbox-otwarty');
        this.wyzwalacz?.focus?.();
      }, czas);
    }

    handleLightboxClick = (event) => {
      if (event.target === this.lightbox || event.target.closest('[data-raporty-lightbox-zamknij]')) this.zamknij();
    };

    handleCancel = (event) => {
      event.preventDefault();
      this.zamknij();
    };

    /** Maksymalne przewinięcie listy (0 = wszystkie karty mieszczą się bez przewijania). */
    get zakres() {
      return Math.max(0, this.lista.scrollWidth - this.lista.clientWidth);
    }

    /** Pozycja przewinięcia, przy której karta zaczyna się na początku listy (ograniczona do zakresu). */
    get pozycje() {
      const lista = this.lista;
      const start = lista.getBoundingClientRect().left + parseFloat(getComputedStyle(lista).paddingLeft);
      const zakres = this.zakres;
      return Array.from(lista.children, (karta) =>
        Math.min(zakres, Math.max(0, karta.getBoundingClientRect().left - start + lista.scrollLeft))
      );
    }

    get indeks() {
      const zakres = this.zakres;
      if (zakres <= 2) return 0;
      const teraz = this.lista.scrollLeft;
      if (teraz >= zakres - 2) return this.lista.children.length - 1;
      let indeks = 0;
      let najblizej = Infinity;
      this.pozycje.forEach((p, i) => {
        const odleglosc = Math.abs(p - teraz);
        if (odleglosc < najblizej) {
          najblizej = odleglosc;
          indeks = i;
        }
      });
      return indeks;
    }

    przewinDo(lewo) {
      const plynnie = !matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.lista.scrollTo({ left: lewo, behavior: plynnie ? 'smooth' : 'auto' });
    }

    // Wstecz/dalej liczone od bieżącej pozycji, a nie od indeksu: przy końcu listy kilka kart
    // ma tę samą (ograniczoną) pozycję, więc „indeks − 1” mogłoby nie przesunąć karuzeli.
    poprzedni = () => {
      const teraz = this.lista.scrollLeft;
      const cel = this.pozycje.filter((p) => p < teraz - 2).pop();
      this.przewinDo(cel ?? 0);
    };

    nastepny = () => {
      const teraz = this.lista.scrollLeft;
      const cel = this.pozycje.find((p) => p > teraz + 2);
      this.przewinDo(cel ?? this.zakres);
    };

    update() {
      const indeks = this.indeks;
      this.suwak.style.transform = `translateX(${indeks * 100}%)`;
      if (this.pozycja) this.pozycja.textContent = `${indeks + 1} / ${this.liczba}`;
      if (this.wstecz) this.wstecz.disabled = indeks === 0;
      if (this.dalej) this.dalej.disabled = indeks === this.liczba - 1 || this.zakres <= 2;
    }
  }

  if (!customElements.get('raporty-badan')) {
    customElements.define('raporty-badan', RaportyBadan);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["skladniki_eksplorator"] && !Shopify.designMode) return;
  try {
    class SkladnikiEksplorator extends HTMLElement {
    connectedCallback() {
      this.desktopQuery = window.matchMedia('(min-width: 750px)');
      this.addEventListener('click', this.handleClick);
      this.desktopQuery.addEventListener('change', this.handleBreakpoint);
      document.addEventListener('shopify:block:select', this.handleEditorSelect);
      this.refresh();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.desktopQuery.removeEventListener('change', this.handleBreakpoint);
      document.removeEventListener('shopify:block:select', this.handleEditorSelect);
    }

    get items() {
      return Array.from(this.querySelectorAll('[data-skladnik]'));
    }

    refresh() {
      const items = this.items;
      this.style.setProperty('--skladniki-count', items.length || 1);
      const active = items.find((item) => item.classList.contains('is-active'));
      this.activate(active || items[0]);
      this.classList.add('is-ready');
    }

    handleClick = (event) => {
      const trigger = event.target.closest('.skladnik__trigger');
      if (!trigger || !this.contains(trigger)) return;
      const item = trigger.closest('[data-skladnik]');
      if (!this.desktopQuery.matches && item.classList.contains('is-active')) {
        this.setState(item, false);
        return;
      }
      this.activate(item);
    };

    handleBreakpoint = () => {
      if (this.desktopQuery.matches && !this.items.some((item) => item.classList.contains('is-active'))) {
        this.activate(this.items[0]);
      }
    };

    handleEditorSelect = (event) => {
      const item = event.target.closest?.('[data-skladnik]');
      if (item && this.contains(item)) this.activate(item);
    };

    activate(target) {
      if (!target) return;
      for (const item of this.items) this.setState(item, item === target);
    }

    setState(item, isActive) {
      item.classList.toggle('is-active', isActive);
      item.querySelector('.skladnik__trigger')?.setAttribute('aria-expanded', String(isActive));
      const panel = item.querySelector('.skladnik__panel');
      if (panel) panel.hidden = !isActive;
    }
  }

  if (!customElements.get('skladniki-eksplorator')) {
    customElements.define('skladniki-eksplorator', SkladnikiEksplorator);
  }
  } catch(e) { console.error(e); }
})();

})();
